import {getSupplier} from "@project/sdk/engineering";
import {GetSupplierResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {supplierKeys} from "../../../supplier-keys";

export function getSupplierQueryOptions(id: string, includeDeleted = false) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: [...supplierKeys.detail(id), {includeDeleted}] as const,
    queryFn: async ({signal}) =>
      GetSupplierResponse.parse(await getSupplier(id, {includeDeleted}, {signal})),
  });
}
